import { render, staticRenderFns } from "./Disciplinas.vue?vue&type=template&id=1fb0bb42&scoped=true"
import script from "./Disciplinas.vue?vue&type=script&lang=ts"
export * from "./Disciplinas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb0bb42",
  null
  
)

export default component.exports